export const SPECIFICATIONS = {
  calls: {
    title: "Calls",
    items: {
      recordings: "Recordings",
      listen: "Listen",
      listenAndWhisper: "Listen and whisper",
      callForwarding: "Call forwarding",
      blacklist: "Blacklist",
    },
  },

  devices: {
    title: "Devices",
    items: {
      softphone: "Softphone",
      phone: "Phone",
      androidApp: "Android app",
      iosApp: "iOS app",
    },
  },

  clients: {
    title: "Clients",
    items: {
      clientCard: "Client card",
      customFields: "Client custom fields",
      tasks: "Tasks",
      callStatuses: "Call statuses",
      reports: "Reports",
      statistics: "Statistics",
    },
  },

  campaigns: {
    title: "Campaigns",
    items: {
      manage: "Campaigns manage",
      scenario: "Scenario",
      customFields: "Campaign custom fields",
      reports: "Reports",
    },
  },

  features: {
    title: "Features",
    items: {
      trueCaller: "True caller",
      office365: "Office 365",
      whatsapp: "Whatsapp",
      billing: "Billing",
      sms: "SMS",
      fax: "Fax",
      ai: "AI",
      api: "API",
    },
  },
};
